import Vue from 'vue'
import Vuex from 'vuex'
import {actions} from "@/store/actions";

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		messages: [],
		conversations: [],
		curConvoId: null,
		notification: {},
	},
	mutations: {
		ADD_MESSAGE(state, payload) {
			state.messages.push(payload);
		},
		setAllConvos(state, payload) {
			state.conversations = payload;
		},
		setCurConvoId(context, payload) {
			context.curConvoId = payload;
		},
		setCurMessages(context, payload) {
			context.messages = payload;
		}
	},
	getters: {
		getMessages(state) {
			return state.conversations;
		},
		getCurConvoId(state) {
			return state.curConvoId;
		}
	},
	actions
});

export default store
